import SxQueryUtils from "../../sxQuery/SxQueryUtils";
import sxQuery from "../../sxQuery/sxQuery";
const TOGGLE_CLASS_NAME = 'ss360-multiselect__checkmark--checked';
const TOGGLE_LABEL_CLASS_NAME = 'ss360-multiselect__label--checked';
class FilterCheckbox {
    constructor(key, name, count, isActive, id, color, icon, isVisible = true, onChange = () => { }) {
        this.isActive = false;
        this.isVisible = true;
        this.onChange = () => { };
        this._isAppended = true;
        this.key = key;
        this.name = name;
        this.count = count;
        this.isActive = isActive;
        this.id = id;
        this.color = color;
        this.icon = icon;
        this.isVisible = isVisible;
        this.onChange = onChange;
    }
    _render() {
        const presentationSpan = document.createElement('span');
        presentationSpan.setAttribute('role', 'presentation');
        presentationSpan.setAttribute('aria-controls', this.id);
        presentationSpan.className = `ss360-multiselect__checkmark${this.isActive ? ` ${TOGGLE_CLASS_NAME}` : ''}`;
        this._presentationSpan = presentationSpan;
        const countString = this.count !== undefined ? (`${this.count}`) : undefined;
        const nameSpan = document.createElement('span');
        nameSpan.textContent = this.name;
        const countSpan = countString !== undefined ? document.createElement('span') : undefined;
        if (countSpan !== undefined) {
            countSpan.className = 'ss360-multiselect__count';
            countSpan.textContent = countString;
        }
        this._countSpan = countSpan;
        const labelNode = document.createElement('label');
        labelNode.setAttribute('for', this.id);
        labelNode.className = `ss360-multiselect__label${this.isActive ? ` ${TOGGLE_LABEL_CLASS_NAME}` : ''}`;
        labelNode.appendChild(presentationSpan);
        labelNode.setAttribute('title', `${this.name}${countString !== undefined ? ` ${countString}` : ''}`);
        const labelTitleWrapperNode = document.createElement('div');
        labelTitleWrapperNode.className = 'ss360-multiselect__label-title-wrapper';
        labelTitleWrapperNode.appendChild(nameSpan);
        if (countSpan !== undefined) {
            labelTitleWrapperNode.appendChild(countSpan);
        }
        labelNode.appendChild(labelTitleWrapperNode);
        if (this.color) {
            const colorNode = document.createElement('span');
            colorNode.className = 'ss360-multiselect__color';
            if (this.color.match(/^#[0-9a-f]{6}$/i) || this.color.match(/^rgb\(\d{1,3},\d{1,3},\d{1,3}\)$/i)) {
                colorNode.style.backgroundColor = this.color;
            }
            else {
                colorNode.style.background = this.color;
            }
            colorNode.setAttribute('role', 'presentation');
            nameSpan.prepend(colorNode);
            nameSpan.className = 'ss360-multiselect__img-wrap ss360-multiselect__img-wrap--color';
        }
        else if (this.icon) {
            const iconNode = document.createElement('img');
            iconNode.className = `ss360-multiselect__icon`;
            iconNode.src = this.icon;
            iconNode.alt = '';
            iconNode.setAttribute('role', 'presentation');
            nameSpan.prepend(iconNode);
            nameSpan.className = 'ss360-multiselect__img-wrap ss360-multiselect__img-wrap--icon';
        }
        this._labelNode = labelNode;
        const wrapperNode = document.createElement('div');
        wrapperNode.className = 'ss360-multiselect__row ss360-flex';
        const inputNode = document.createElement('input');
        inputNode.id = this.id;
        inputNode.type = 'checkbox';
        inputNode.className = 'ss360-multiselect__checkbox';
        this._inputNode = inputNode;
        inputNode.value = this.key;
        if (this.isActive) {
            inputNode.setAttribute('checked', 'checked');
        }
        const onChange = () => {
            this.onChange(this.key, !this.isActive);
            this.isActive = !this.isActive;
            this._onActiveUpdated();
        };
        inputNode.addEventListener('change', () => {
            onChange();
        });
        wrapperNode.appendChild(inputNode);
        wrapperNode.appendChild(labelNode);
        if (!this.isVisible) {
            wrapperNode.setAttribute('style', 'display:none;');
        }
        const checkerRow = sxQuery(undefined);
        checkerRow.push([wrapperNode]);
        this._domNode = checkerRow;
    }
    getDomNode() {
        if (this._domNode === undefined) {
            this._render();
        }
        return this._domNode;
    }
    show() {
        if (this.isVisible || this._domNode === undefined) {
            return;
        }
        this.isVisible = true;
        this._domNode.show();
    }
    hide() {
        if (!this.isVisible || this._domNode === undefined) {
            return;
        }
        this.isVisible = false;
        this._domNode.hide();
    }
    remove() {
        if (!this._isAppended || this._domNode === undefined) {
            return;
        }
        this._isAppended = false;
        this._domNode.remove();
    }
    ensureLastPosition(wrap) {
        const isActive = SxQueryUtils.isElementActive(this._inputNode);
        wrap.append(this._domNode.get(0));
        if (isActive) {
            setTimeout(() => {
                sxQuery(this._inputNode).focus();
            }, 0);
        }
    }
    isAppended() {
        return this._isAppended;
    }
    updateCount(count) {
        this.count = count;
        const { _countSpan } = this;
        if (count === undefined && _countSpan !== undefined) {
            sxQuery(_countSpan).remove();
        }
        else if (count !== undefined && _countSpan !== undefined) {
            _countSpan.textContent = `${count}`;
        }
    }
    _onActiveUpdated(updateInput = false) {
        const $checkmark = sxQuery(this._presentationSpan);
        const $label = sxQuery(this._labelNode);
        if (this.isActive) {
            $checkmark.addClass(TOGGLE_CLASS_NAME);
            $label.addClass(TOGGLE_LABEL_CLASS_NAME);
        }
        else {
            $checkmark.removeClass(TOGGLE_CLASS_NAME);
            $label.removeClass(TOGGLE_LABEL_CLASS_NAME);
        }
        if (updateInput) {
            sxQuery(this._inputNode).attr('checked', this.isActive ? 'checked' : null);
        }
    }
    updateActive(isActive) {
        this.isActive = isActive;
        this._onActiveUpdated(true);
    }
}
export default FilterCheckbox;
